import React from 'react';
import { connect } from 'react-redux';
import { Navbar } from 'react-bootstrap';

import HeaderLoggedOutMobile from "./HeaderLoggedOutMobile.js";
import HeaderLoggedOutDesktop from "./HeaderLoggedOutDesktop.js";
import HeaderLoggedInDesktop from "./HeaderLoggedInDesktop.js";
import HeaderLoggedInMobile from "./HeaderLoggedInMobile.js";

const Header = ({auth}) => {

    // Check localStorage first for immediate UI response
    const isAuthenticatedLocal = localStorage.getItem('isAuthenticated') === 'true';
    
    // Show logged-in header only if we have both localStorage AND actual auth data
    // This prevents showing logged-in components when auth data is still loading
    const shouldShowLoggedIn = isAuthenticatedLocal && auth && auth.id;
    
    // If localStorage says authenticated but no auth data yet, show basic header
    if (isAuthenticatedLocal && (!auth || !auth.id)) {
        return (
            <>   
                {/*MOBILE*/}
                <div className="d-block d-lg-none">
                    <Navbar fixed="top" expand="md" className="navbar-custom" style={{
                        background: 'rgba(255, 255, 255, 0.98)',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)'
                    }}>
                        <Navbar.Brand className="p-0" style={{marginLeft:"10px", marginRight:"10px"}}>
                            <a href="/dashboard" style={{color: "#2d3748",textDecoration:"none", fontWeight:"500"}}>
                                Elliot Koss
                            </a>
                        </Navbar.Brand>
                    </Navbar>
                </div>
    
                {/*DESKTOP*/}
                <div className="d-lg-block d-none">
                    <Navbar fixed="top" expand="lg" className="navbar-custom" style={{
                        height:"56px", 
                        background: 'rgba(255, 255, 255, 0.98)',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        paddingRight:"5px"
                    }}>
                        <Navbar.Brand>
                            <a href="/" style={{color: "#2d3748",textDecoration:"none", marginLeft:"10px", fontWeight:"500"}}>
                                Elliot Koss
                            </a>
                        </Navbar.Brand>
                    </Navbar>
                </div>
            </>
        );
    }
    
    if (shouldShowLoggedIn) {
        return (
            <>   
                {/*MOBILE*/}
                <HeaderLoggedInMobile />
    
                {/*DESKTOP*/}
                <HeaderLoggedInDesktop />
            </>
        );
    } else {
        return (
            <>   
                {/*MOBILE*/}
                <HeaderLoggedOutMobile />
    
                {/*DESKTOP*/}
                <HeaderLoggedOutDesktop />
            </>
        );
    }        
}

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Header);